"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.useContentHeight = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
function useContentHeight(element) {
    var _a = tslib_1.__read(react_1.useState(-1), 2), contentHeight = _a[0], setContentHeight = _a[1];
    react_1.useEffect(function () {
        var id = -1;
        function onFrame() {
            if (element && contentHeight !== element.scrollHeight) {
                setContentHeight(element.scrollHeight);
            }
            id = window.requestAnimationFrame(onFrame);
        }
        id = window.requestAnimationFrame(onFrame);
        return function () { return window.cancelAnimationFrame(id); };
    }, [element, contentHeight, setContentHeight]);
    return contentHeight;
}
exports.useContentHeight = useContentHeight;
//# sourceMappingURL=useContentHeight.js.map